<template>
  <template v-if="screenWidth === 'mobile'">
    <div
      v-if="screenWidth === 'mobile' && isFilled"
      class="step-info"
      :class="{ _filled: isFilled }"
      @click="openFilterCompletedModal"
    >
      <BookingStepInfo
        icon-type="IconBookingPerson"
        class="step-info-step _short"
        map
        short
        filled
      />
      <BookingStepInfo
        icon-type="IconBookingCalendar"
        class="step-info-step _short"
        map
        short
        filled
      />
      <BookingStepInfo
        icon-type="IconBookingDuration"
        class="step-info-step _short"
        map
        short
        filled
      />
      <BookingStepInfo
        icon-type="IconBookingTime"
        class="step-info-step _short"
        map
        short
        filled
      />
      <VButton
        class="button"
        outline
        large
        :style="{ width: '112px', height: '44px' }"
      >
        Изменить
      </VButton>
    </div>

    <div v-else-if="$route.name !== 'map/:catId'" class="mobile-bottom-wrapper">
      <div
        class="mobile-bottom-inner"
        :style="{ height: '84px', borderRadius: 0 }"
      ></div>
      <div
        class="mobile-bottom-inner"
        :style="{ transform: `translateY(${translateY}px)` }"
        :class="{ _extended: isExpanded }"
      >
        <SwipeWrapper
          @pan-start="onPanStart"
          @pan-move="onPanMove"
          @pan-end="onPanEnd"
        >
          <div class="mobile-bottom-swipe"></div>
        </SwipeWrapper>
        <VButton
          v-if="!isExpanded"
          @click="accept"
          large
          class="mobile-bottom-button"
        >
          Подобрать столик
        </VButton>
        <div
          v-else
          :style="{ display: 'flex', flexDirection: 'column', height: '100%' }"
        >
          <div class="lines">
            <div class="line _active" />
            <div class="line" />
            <div class="line" />
            <div class="line" />
          </div>
          <div class="main-block">
            <h2>Сколько вас будет?</h2>
            <p class="message">
              Поможем найти идеальное место — от романтического ужина на двоих
              до весёлой встречи с друзьями.
            </p>
            <Counter v-model="currentVisitorsCount" :min-value="1" />
          </div>
          <div class="inner-buttons">
            <div class="prev-button" v-if="screenWidth === 'mobile'">
              <IconArrowButton color="#ADADAD" />
            </div>
            <VButton @click="onNextClickHandler" class="inner-button">
              <template v-if="screenWidth === 'mobile'" #rightAddon>
                <IconArrowButton color="#ffffff" />
              </template>
              <template #default>Далее</template>
            </VButton>
          </div>
        </div>
      </div>
    </div>
  </template>

  <template
    v-else-if="
      (screenWidth === 'l-laptop' ||
        screenWidth === 'tablet' ||
        screenWidth === 'laptop') &&
      isFilled &&
      isTabletShort
    "
  >
    <div
      class="step-info"
      :class="{ _filled: isFilled }"
      @click="openVisitorsModal"
    >
      <div
        :style="{
          display: 'flex',
          justifyContent: 'space-between',
          width: '248px',
        }"
      >
        <BookingStepInfo
          icon-type="IconBookingPersonBig"
          class="step-info-step _short"
          map
          short
          filled
        />
        <BookingStepInfo
          icon-type="IconBookingCalendarBig"
          class="step-info-step _short"
          map
          short
          filled
        />
        <BookingStepInfo
          icon-type="IconBookingDurationBig"
          class="step-info-step _short"
          short
          map
          filled
        />
        <BookingStepInfo
          icon-type="IconBookingTimeBig"
          class="step-info-step _short"
          map
          short
          filled
        />
      </div>

      <VButton class="button" large :style="{ width: '248px', height: '56px' }">
        Найти столик
      </VButton>
    </div>
  </template>

  <div v-else-if="isFilled" class="step-info _filled">
    <div class="step-info-row">
      <BookingStepInfo
        icon-type="IconBookingPersonBig"
        :text="filterVisitors + ' чел'"
        class="step-info-step"
        @click="openVisitorsModal"
        map
        filled
      />
      <BookingStepInfo
        icon-type="IconBookingCalendarBig"
        :text="filterDate.toLocaleDateString('ru')"
        class="step-info-step"
        @click="openDateModal"
        map
        filled
      />
    </div>
    <div class="step-info-row">
      <BookingStepInfo
        icon-type="IconBookingDurationBig"
        :text="filterDuration / 60 + ' ч'"
        class="step-info-step"
        @click="openDurationModal"
        map
        filled
      />
      <BookingStepInfo
        icon-type="IconBookingTimeBig"
        :text="`${filterTime.hours}:${
          filterTime.minutes === 0 ? '00' : filterTime.minutes
        }`"
        class="step-info-step"
        @click="openTimeModal"
        map
        filled
      />
    </div>
    <AcceptModalButton
      acceptButtonText="Да"
      cancelButtonText="Не отменять"
      title="Отменить выбранные параметры поиска?"
      text="После закрытия окна поиск мест по выбранным критериям будет очищен."
      @accept="resetFilter"
      v-slot="scope"
    >
      <VButton
        v-if="
          screenWidth === 'l-laptop' ||
          screenWidth === 'tablet' ||
          screenWidth === 'laptop'
        "
        @click="scope.open"
        gray
        outline
        large
        :style="{ width: '410px', height: '56' }"
      >
        Очистить
      </VButton>
      <div v-else class="cross" @click="scope.open">
        <IconCross color="#858585" />
      </div>
    </AcceptModalButton>
  </div>

  <div
    v-else
    class="step-info"
    @click="openVisitorsModal"
    :class="{
      _tablet:
        screenWidth === 'tablet' ||
        screenWidth === 'l-laptop' ||
        screenWidth === 'laptop',
    }"
  >
    <div class="step-info-row">
      <BookingStepInfo
        icon-type="IconBookingPersonBig"
        class="step-info-step _short"
        map
        short
      />
      <BookingStepInfo
        icon-type="IconBookingCalendarBig"
        class="step-info-step _short"
        map
        short
      />
      <BookingStepInfo
        icon-type="IconBookingDurationBig"
        class="step-info-step _short"
        short
        map
      />
      <BookingStepInfo
        icon-type="IconBookingTimeBig"
        class="step-info-step _short"
        map
        short
      />
    </div>
    <VButton large class="button">Найти столик</VButton>
  </div>
</template>

<script>
import BookingStepInfo from "@/components/pages/client-booking/BookingStepInfo.vue";
import FilterDateModal from "@/components/modals/mapCateringFilter/FilterDateModal.vue";
import FilterTimeModal from "@/components/modals/mapCateringFilter/FilterTimeModal.vue";
import FilterVisitorsModal from "@/components/modals/mapCateringFilter/FilterVisitorsModal.vue";
import FilterDurationModal from "@/components/modals/mapCateringFilter/FilterDurationModal.vue";
import VButton from "@/components/ui/VButton.vue";
import IconCross from "@/components/icons/IconCross.vue";
import { isProd } from "@/assets/js/utils/helpers";
import CompletedFilterMapModal from "@/components/modals/CompletedFilterMapModal.vue";
import AcceptModalButton from "@/components/modals/AcceptModalButton.vue";
import SwipeWrapper from "@/components/ui/SwipeWrapper.vue";
import Counter from "@/components/pages/client-booking/Counter.vue";
import IconArrowButton from "@/components/icons/IconArrowButton.vue";

export default {
  name: "FilterRestaurantsForBooking",
  components: {
    IconArrowButton,
    Counter,
    SwipeWrapper,
    AcceptModalButton,
    IconCross,
    VButton,
    BookingStepInfo,
  },

  data() {
    return {
      modal: "",
      centerCoords: [56.834463, 60.600582],
      currentVisitorsCount: 1,
      translateY: 0,
      startY: 0,
      isExpanded: false,
    };
  },

  methods: {
    async onNextClickHandler() {
      this.$store.commit({
        type: "setFilterVisitors",
        value: this.currentVisitorsCount,
      });
      await this.$store.dispatch("openMobileModal", {
        value: {
          component: FilterDateModal,
          props: {},
        },
      });
      this.isExpanded = false;
    },
    accept() {
      if (isProd()) {
        window.ym(99602273, "reachGoal", "find_a_table_click");
      }
      this.$store.dispatch("openMobileModal", {
        value: {
          component: FilterVisitorsModal,
          props: {},
        },
      });
    },
    openFilterCompletedModal() {
      this.$store.dispatch("openMobileModal", {
        value: {
          component: CompletedFilterMapModal,
          props: {},
        },
      });
    },
    onArrowClickHandler() {
      if (isProd()) {
        window.ym(99602273, "reachGoal", "filter_button");
      }
      this.$store.commit({ type: "setIsFilterFull", value: true });
    },
    openDurationModal() {
      this.$store.dispatch("openModal", {
        value: {
          component: FilterDurationModal,
          props: {},
        },
      });
    },
    openDateModal() {
      this.$store.dispatch("openModal", {
        value: {
          component: FilterDateModal,
          props: {},
        },
      });
    },
    openTimeModal() {
      this.$store.dispatch("openModal", {
        value: {
          component: FilterTimeModal,
          props: {},
        },
      });
    },
    openVisitorsModal() {
      if (isProd()) {
        window.ym(99602273, "reachGoal", "find_a_table_click");
      }
      this.$store.commit({
        type: "setClickedCluster",
        value: null,
      });
      this.$store.dispatch("openModal", {
        value: {
          component: FilterVisitorsModal,
          props: {},
        },
      });
    },

    async resetFilter() {
      this.$store.commit({
        type: "resetCatFilter",
      });
      await this.$store.dispatch("getClientRestaurants", {
        value: { city: this.city.city, settlement: "" },
      });
    },

    onPanStart(e) {
      this.startY = e.center.y;
    },
    onPanMove(e) {
      if (this.isExpanded) {
        if (e.deltaY > 0) {
          this.translateY = e.deltaY;
        }
      }

      const deltaY = e.center.y - this.startY;
      if (deltaY < 0) {
        this.translateY = deltaY < -84 ? -84 : deltaY;
      }
    },
    onPanEnd() {
      if (this.isExpanded) {
        if (Math.abs(this.translateY) > 100) {
          this.translateY = 0;
          this.isExpanded = false;
        } else {
          this.translateY = 0;
          this.isExpanded = true;
        }
        return;
      }

      if (Math.abs(this.translateY) > 50) {
        this.translateY = 0;
        this.isExpanded = true;
      } else {
        this.translateY = 0;
      }
    },
  },

  async mounted() {
    if (this.screenWidth === "mobile") {
      this.$store.commit({ type: "setIsFilterFull", value: true });
    }
  },

  computed: {
    city() {
      return this.$store.state.general.city;
    },
    isFilterFull() {
      return (
        this.$store.state.clientRestaurants.isFilterFull &&
        this.$route.name !== "map/:catId"
      );
    },
    isFilter() {
      return this.$store.state.clientRestaurants.isFilter;
    },
    filteredItems() {
      return this.$store.state.clientRestaurants.filteredItems;
    },
    screenWidth() {
      return this.$store.getters.screenType;
    },
    filterDate() {
      return this.$store.state.clientRestaurants.filter.date;
    },
    filterTime() {
      return this.$store.state.clientRestaurants.filter.time;
    },
    filterVisitors() {
      return this.$store.state.clientRestaurants.filter.visitors;
    },
    filterDuration() {
      return this.$store.state.clientRestaurants.filter.duration;
    },
    isFilled() {
      return this.$store.getters.isMapFilterFilled;
    },
    isTabletShort() {
      return (
        this.$route.name === "map/:catId" ||
        this.$store.state.clientRestaurants.clickedCluster
      );
    },
    blockHeight() {
      if (this.isExpanded) {
        return 632 - this.translateY;
      } else {
        return 100 - this.translateY;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.step-info {
  position: fixed;
  left: calc(50% + 168px);
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  height: 72px;
  padding: 8px;
  gap: 8px;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 8px 10px 0 #00000014;
  z-index: 1999;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    width: 16px;
    height: 16px;
    background-size: contain;
    background-repeat: no-repeat;

    @include mobile {
      display: none;
    }
  }

  &::before {
    left: -15px;
    background-image: url("@/assets/images/icons/left-angle.svg");
  }

  &::after {
    right: -16px;
    background-image: url("@/assets/images/icons/right-angle.svg");
  }

  @include l-laptop {
    height: auto;
    flex-direction: column;
    left: auto;
    right: 16px;
  }

  &._filled {
    top: 68px;

    @include l-laptop {
      flex-direction: column;
      height: auto;
    }

    @include mobile {
      flex-direction: row;
      left: 16px;
      right: auto;
      bottom: 16px;
      top: auto;
      border-radius: 16px;
      transform: translateX(0);
    }
  }

  &._tablet {
    .step-info-row {
      width: 100%;
      gap: 8px;
      justify-content: space-between;
    }
    button {
      width: 248px;
    }
  }

  .step-info-row {
    gap: 8px;
    display: flex;
  }

  .step-info-step {
    background-color: #f6f6f6;
    width: 194px;
    cursor: pointer;

    &._short {
      width: auto;
    }

    @include mobile {
      background-color: #fff;
      box-shadow: none;
    }
  }
}

.cross {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 56px;
  border-radius: 12px;
  border: 2px solid #858585;
  cursor: pointer;
}

.mobile-bottom-wrapper {
  z-index: 1111111111;
  .mobile-bottom-inner {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 448px;
    margin: auto;
    padding: 32px 56px 40px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    @media screen and (max-width: 841px) {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      box-shadow: 0 -2px 10px 0 #0000000d;
      border-radius: 20px 20px 0 0;
      padding: 20px 16px 16px;

      &._extended {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        max-width: 100%;
        box-shadow: 0 -2px 10px 0 #0000000d;
        border-radius: 20px 20px 0 0;
        padding: 40px 16px 24px 16px;
        min-height: 632px;
        max-height: 632px;
        height: 632px;
      }
    }
  }

  .mobile-bottom-button {
    width: 100%;
    height: 48px;
  }

  .mobile-bottom-swipe {
    display: block;
    position: absolute;
    width: 100%;
    height: 20px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 16px 16px 0 0;
    background-color: #ffffff;

    &::before {
      content: "";
      left: 50%;
      position: absolute;
      top: 6px;
      transform: translate(-50%);
      width: 36px;
      height: 6px;
      border-radius: 4px;
      background-color: #d6d6d6;
    }
  }
}

.under-block {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f5f5f5;
  padding: 20px;
  height: 300px;
  transition: opacity 0.3s ease, transform 0.3s ease;
  border-radius: 20px 20px 0 0;
  z-index: 1;
}

.lines {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 64px;
  gap: 10px;

  @include mobile {
    width: 100%;
    height: 8px;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 32px;
    padding: 0 4px;
    border-radius: 8px;
    background-color: white;
  }
}

.line {
  width: 122px;
  height: 8px;
  border-radius: 8px;
  background-color: #adadad;

  @include mobile {
    width: calc(25% - 4px);
    border-radius: 8px;
  }

  &._active {
    background-color: #f18e35;
    cursor: pointer;
  }
}

.main-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 162px;

  @include mobile {
    padding: 0 0 162px;
  }
}

.message {
  max-width: 528px;
  margin-top: 16px;
  margin-bottom: 120px;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #858585;

  @include mobile {
    margin-top: 0;
    margin-bottom: 100px;
  }
}

.inner-buttons {
  display: flex;
  justify-content: center;
  margin-top: 32px;
  width: 100%;
  gap: 16px;

  @include mobile {
    margin-top: auto;
  }
}

.inner-button {
  height: 40px;
  width: 120px;
  padding: 9px 38px;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;

  @include mobile {
    width: 100%;
    border-radius: 100px;

    &:first-child {
      margin-bottom: 16px;
    }
  }
}

.prev-button {
  display: flex;
  flex: 0 0 auto;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #adadad;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
    transform: rotate(180deg);
  }
}

h2 {
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;

  @include mobile {
    margin-bottom: 16px;
  }
}
</style>
